import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import SharedPreferences from "../core/utils/SharedPreferences";
import { STORAGE_KEYS } from "../data/constant/Constants";

export const supportedLngs = {
  en: "English",
  ar: "Arabic (العربية)",
};

const isDev = process.env.NODE_ENV === "development";

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    lng: SharedPreferences.getString(STORAGE_KEYS.LANGUAGE) ?? "ar",
    fallbackLng: "en",
    debug: isDev,
    supportedLngs: Object.keys(supportedLngs),
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
